import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import { NguCarouselModule } from "@ngu/carousel";
import { NgxCurrencyModule } from "ngx-currency";
import { IConfig, NgxMaskModule } from "ngx-mask";
import { AvaregeFormatModule } from "src/app/pipes/avarege/avarege-format.module";
import { customCurrencyMaskConfig } from "../domain/interfaces/custom-currency-mask.interface";
import { ParcelamentoPremioPropostaComponent } from "../pages/components/parcelamento-premio-proposta/parcelamento-premio-proposta.component";
import { CpfCnpjModule } from "../pipes/cpf-cnpj/cpf-cnpj-format.module";
import { DoubtsMenuComponent } from "../ui/doubts-menu/doubts-menu.component";
import { NotificationComponent } from "../ui/notification/notification.component";
import { AlertDialogComponent } from "./alert-dialog/alert-dialog.component";
import { AlertTooltipComponent } from "./alert-tooltip/alert-tooltip.component";
import { AlertComponent } from "./alerts/alert.component";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { ButtonFormComponent } from "./button-form/button-form.component";
import { CardCreateComponent } from "./card-create/card-create.component";
import { CardComponent } from "./card/card.component";
import { ChipsComponent } from "./chips/chips.component";
import { ClauseTableComponent } from "./clause-table/clause-table.component";
import { DialogDynamicComponent } from "./dialog-dynamic/dialog-dynamic.component";
import { DialogTermsComponent } from "./dialog-terms/dialog-terms.component";
import { DialogComponent } from "./dialog/dialog.component";
import { FieldGroupComponent } from "./field-group/field-group.component";
import { FileUploaderComponent } from "./file-uploader/file-uploader.component";
import { GradientLoadingComponent } from "./gradient-loading/gradient-loading.component";
import { HeaderTitleWithButtonComponent } from "./header-title-with-button/header-title-with-button.component";
import { HeaderTitleComponent } from "./header-title/header-title.component";
import { HomeCarouselComponent } from "./home-carousel/home-carousel.component";
import { InsuredObjectComponentComponent } from "./insured-object-component/insured-object-component.component";
import { LoadComponent } from "./load/load.component";
import { MetricasSliderComponent } from "./metricas-slider/metricas-slider.component";
import { RadioButtonProposals } from "./radio-button-proposals/radio-button-proposals.component";
import { SnackBarComponent } from "./snack-bar/snack-bar.component";
import { SpinnerComponent } from "./spinner/spinner.component";
import { TableCreateComponent } from "./table-create/table-create.component";
import { TableComponent } from "./table/table.component";
import { TaxaMixComponent } from "./taxa-mix/taxa-mix.component";
import { TipoSetorPropostaComponent } from "./tipo-setor-proposta/tipo-setor-proposta.component";
import { TreeDragDropComponent } from "./tree-drag-drop/tree-drag-drop.component";
import { TreeComponent } from "./tree/tree.component";

const maskConfig: Partial<IConfig> = {
	validation: false
};

@NgModule({
	declarations: [
		CardCreateComponent,
		TableCreateComponent,
		BreadcrumbComponent,
		HeaderTitleComponent,
		ButtonFormComponent,
		HeaderTitleWithButtonComponent,
		FieldGroupComponent,
		SnackBarComponent,
		DialogComponent,
		DialogDynamicComponent,
		SpinnerComponent,
		TableComponent,
		CardComponent,
		ChipsComponent,
		LoadComponent,
		TreeComponent,
		AlertDialogComponent,
		ClauseTableComponent,
		DialogTermsComponent,
		AlertTooltipComponent,
		DialogTermsComponent,
		TaxaMixComponent,
		ParcelamentoPremioPropostaComponent,
		NotificationComponent,
		DoubtsMenuComponent,
		RadioButtonProposals,
		TipoSetorPropostaComponent,
		TreeDragDropComponent,
		InsuredObjectComponentComponent,
		FileUploaderComponent,
		HomeCarouselComponent,
		MetricasSliderComponent,
		GradientLoadingComponent,
		AlertComponent
	],
	imports: [
		CommonModule,
		MatIconModule,
		MatButtonModule,
		MatFormFieldModule,
		MatProgressSpinnerModule,
		MatInputModule,
		ReactiveFormsModule,
		FormsModule,
		MatTableModule,
		MatCardModule,
		MatChipsModule,
		MatTooltipModule,
		MatSelectModule,
		NgxMaskModule.forRoot(maskConfig),
		NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
		MatTreeModule,
		MatRadioModule,
		MatExpansionModule,
		MatCheckboxModule,
		AvaregeFormatModule,
		CpfCnpjModule,
		MatMenuModule,
		MatAutocompleteModule,
		DragDropModule,
		NguCarouselModule
	],
	exports: [
		CardCreateComponent,
		TableCreateComponent,
		BreadcrumbComponent,
		HeaderTitleComponent,
		ButtonFormComponent,
		HeaderTitleWithButtonComponent,
		FieldGroupComponent,
		SnackBarComponent,
		DialogComponent,
		DialogDynamicComponent,
		ReactiveFormsModule,
		FormsModule,
		MatFormFieldModule,
		MatInputModule,
		SpinnerComponent,
		TableComponent,
		CardComponent,
		ChipsComponent,
		LoadComponent,
		TreeComponent,
		ClauseTableComponent,
		AlertTooltipComponent,
		ClauseTableComponent,
		TaxaMixComponent,
		ParcelamentoPremioPropostaComponent,
		NotificationComponent,
		DoubtsMenuComponent,
		RadioButtonProposals,
		TipoSetorPropostaComponent,
		TreeDragDropComponent,
		InsuredObjectComponentComponent,
		FileUploaderComponent,
		HomeCarouselComponent,
		MetricasSliderComponent,
		GradientLoadingComponent,
		AlertComponent
	]
})
export class UiModule {}
